module.exports = __webpack_public_path__ + "static/media/linjal.2181cc97.mp3";